import styled from '@emotion/styled';

export const NoWrapCell = styled.div({
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
});
